import { type VariablesOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation DocumentImageArchiveListPage_UpdateDocumentImageStatus(
    $documentImageId: ID!
    $newStatus: DocumentImageStatusType!
  ) {
    changeDocumentImageStatus(
      documentImageId: $documentImageId
      newStatus: $newStatus
    ) {
      ok
    }
  }
`)
type Variables = VariablesOf<typeof document>

export const useUpdateDocumentImageStatusMutation = (
  options: Omit<
    UseMutationOptions<void, unknown, Variables, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (variables) => {
      const result = await graphQLRequest({ document, variables })
      const ok = result.changeDocumentImageStatus?.ok ?? false
      if (!ok) {
        throw new Error(t('update_failed'))
      }
    },
    ...options,
  })
}
